<template>
  <transition name="magic-ui-toast-pop">
    <div
      v-show="visible"
      class="magic-ui-toast"
      :class="customClass"
      :style="{ 'padding': iconClass === '' ? '0.14rem 0.16rem' : '20px' }"
    >
      <i
        v-if="iconClass !== ''"
        class="magic-ui-toast-icon"
        :class="iconClass"
      />
      <span
        class="magic-ui-toast-text"
        :style="{ 'padding-top': iconClass === '' ? '0' : '10px' }"
      >{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MagicUiToast',

  props: {
    message: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'middle',
    },
    iconClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      visible: false,
    };
  },

  computed: {
    customClass() {
      const classes = [];
      switch (this.position) {
        case 'top':
          classes.push('is-placetop');
          break;
        case 'bottom':
          classes.push('is-placebottom');
          break;
        default:
          classes.push('is-placemiddle');
      }
      classes.push(this.className);
      return classes.join(' ');
    },
  },
};
</script>

<style lang="scss">
.magic-ui-toast {
    position: fixed;
    max-width: 80%;
    border-radius: 0.08rem;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    word-wrap:break-word;
    box-sizing: border-box;
    text-align: center;
    z-index: 1000;
    -webkit-transition: opacity .3s linear;
    transition: opacity .3s linear
}
.magic-ui-toast.is-placebottom {
    bottom: 50px;
    left: 50%;
    -webkit-transform: translate(-50%, 0);
            transform: translate(-50%, 0)
}
.magic-ui-toast.is-placemiddle {
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%)
}
.magic-ui-toast.is-placetop {
    top: 50px;
    left: 50%;
    -webkit-transform: translate(-50%, 0);
            transform: translate(-50%, 0)
}
.magic-ui-toast-icon {
    display: block;
    text-align: center;
    font-size: 56px
}
.magic-ui-toast-text {
    font-size: 0.14rem;
    font-weight: 500;
    display: block;
    text-align: center
}
.magic-ui-toast-pop-enter, .magic-ui-toast-pop-leave-active {
    opacity: 0
}
</style>
